// TODO: ADICIONAR VALIDAÇÕES DE ACESSO AQUI

import {
    exibirSolicitacaoMaterial,
    exibirSolicitacaoServico,
    exibirSolicitacaoPassagem,
    exibirSolicitacaoHospedagem,
    exibirSolicitacaoDiarias,
    exibirSolicitacaoPagamentoBolsa,
    exibirSolicitacaoPagamentoBolsaEventual,
    exibirSolicitacaoPagamentoPremiacao,
    exibirSolicitacaoLocacaoVeiculo,
    exibirSolicitacaoCadastroPessoaJuridica,
    exibirSolicitacaoCancelamentoContrato,
    exibirSolicitacaoCadastroPessoaFisica,
} from '@/commons/solicitacoes.js'

export default [
    // Detalhe de Solicitação
    {
        path: '/solicitacao/:id',
        name: 'detalheSolicitacao',
        component: () => import('@/modules/projeto/views/detalhes/DetalheSolicitacaoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Avaliação de Solicitação Pagamento de Serviço
    {
        path: '/solicitacao/:id/pagamentoservico',
        name: 'avaliarSolicitacaoPagamentoServico',
        component: () => import('@/modules/projeto/views/detalhes/AvaliarSolicitacaoPagamentoServicoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Avaliação de Solicitação Recarga de Cartão
    {
        path: '/solicitacao/:id/recargacartao',
        name: 'avaliarSolicitacaoRecargaCartao',
        component: () => import('@/modules/projeto/views/detalhes/AvaliarSolicitacaoRecargaCartaoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },

    // Cadastro Solicitacao de Auxilio Financeiro
    {
        path: '/projetos/:id/solicitacaoauxiliofinanceiro/',
        name: 'cadastroSolicitacaoAuxilioFinanceiro',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAuxilioFinanceiroView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição Solicitacao de Auxilio Financeiro
    {
        path: '/solicitacaoauxiliofinanceiro/:idsolicitacao',
        name: 'edicaoSolicitacaoAuxilioFinanceiro',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAuxilioFinanceiroView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro Solicitacao de Auxilio Deslocamento
    {
        path: '/projetos/:id/solicitacaoauxiliodeslocamento/',
        name: 'cadastroSolicitacaoAuxilioDeslocamento',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAuxilioDeslocamentoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição Solicitacao de Auxilio Deslocamento
    {
        path: '/solicitacaoauxiliodeslocamento/:idsolicitacao',
        name: 'edicaoSolicitacaoAuxilioDeslocamento',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAuxilioDeslocamentoView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro Solicitacao de Ajuda de Custo para Estudantes em Viagem
    {
        path: '/projetos/:id/solicitacaoajudacustoestudantesviagem/',
        name: 'cadastroSolicitacaoAjudaCustoEstudantesViagem',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAjudaCustoEstudantesViagemView.vue'),
        meta: { requiresAuth: true },
        props: true
    },

    // Edição Solicitacao de Ajuda de Custo para Estudantes em Viagem
    {
        path: '/solicitacaoajudacustoestudantesviagem/:idsolicitacao',
        name: 'edicaoSolicitacaoAjudaCustoEstudantesViagem',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAjudaCustoEstudantesViagemView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro Solicitacao de Ajuda de Custo Estudante
    {
        path: '/projetos/:id/solicitacaoajudacustoestudante/',
        name: 'cadastroSolicitacaoAjudaCustoEstudante',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAjudaCustoEstudanteView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição Solicitacao de Ajuda de Custo Estudante
    {
        path: '/solicitacaoajudacustoestudante/:idsolicitacao',
        name: 'edicaoSolicitacaoAjudaCustoEstudante',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAjudaCustoEstudanteView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro Solicitacao de Passagem
    {
        path: '/projetos/:id/solicitacaopassagem/',
        name: 'cadastroSolicitacaoPassagem',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPassagemView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoPassagem ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Passagem
    {
        path: '/solicitacaopassagem/:idsolicitacao',
        name: 'edicaoSolicitacaoPassagem',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPassagemView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoPassagem ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro Solicitacao de Material
    {
        path: '/projetos/:id/solicitacaomaterial/',
        name: 'cadastroSolicitacaoMaterial',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoMaterialView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoMaterial ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Material
    {
        path: '/solicitacaomaterial/:idsolicitacao',
        name: 'edicaoSolicitacaoMaterial',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoMaterialView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoMaterial ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro Solicitacao de Serviço
    {
        path: '/projetos/:id/solicitacaoservico/',
        name: 'cadastroSolicitacaoServico',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoServicoView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoServico ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Serviço
    {
        path: '/solicitacaoservico/:idsolicitacao',
        name: 'edicaoSolicitacaoServico',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoServicoView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoServico ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro Solicitacao de Pagamento de Bolsa
    {
        path: '/projetos/:id/solicitacaopagamentobolsa/',
        name: 'cadastroSolicitacaoPagamentoBolsa',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoBolsaView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoPagamentoBolsa ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Pagamento de Bolsa
    {
        path: '/solicitacaopagamentobolsa/:idsolicitacao',
        name: 'edicaoSolicitacaoPagamentoBolsa',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoBolsaView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoPagamentoBolsa ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro Solicitacao de Pagamento de Bolsa Eventual
    {
        path: '/projetos/:id/solicitacaopagamentobolsaeventual/',
        name: 'cadastroSolicitacaoPagamentoBolsaEventual',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoBolsaEventualView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoPagamentoBolsaEventual ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Pagamento de Bolsa Eventual
    {
        path: '/solicitacaopagamentobolsaeventual/:idsolicitacao',
        name: 'edicaoSolicitacaoPagamentoBolsaEventual',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoBolsaEventualView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoPagamentoBolsaEventual ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro Solicitacao de Hospedagem
    {
        path: '/projetos/:id/solicitacaohospedagem/',
        name: 'cadastroSolicitacaoHospedagem',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoHospedagemView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoHospedagem ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Hospedagem
    {
        path: '/solicitacaohospedagem/:idsolicitacao',
        name: 'edicaoSolicitacaoHospedagem',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoHospedagemView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoHospedagem ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro Solicitacao de Diaria
    {
        path: '/projetos/:id/solicitacaodiaria/',
        name: 'cadastroSolicitacaoDiaria',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoDiariasView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoDiarias ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Diaria
    {
        path: '/solicitacaodiaria/:idsolicitacao',
        name: 'edicaoSolicitacaoDiaria',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoDiariasView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoDiarias ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro Solicitacao de Pagamento de Serviço
    {
        path: '/projetos/:id/solicitacaopagamentoservico/',
        name: 'cadastroSolicitacaoPagamentoServico',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoServicoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição Solicitacao de Pagamento de Serviço
    {
        path: '/solicitacaopagamentoservico/:idsolicitacao',
        name: 'edicaoSolicitacaoPagamentoServico',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoServicoView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro Solicitacao de Recarga de Cartão
    {
        path: '/projetos/:id/solicitacaorecargacartao/',
        name: 'cadastroSolicitacaoRecargaCartao',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoRecargaCartaoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição Solicitacao de Recarga de Cartão
    {
        path: '/solicitacaorecargacartao/:idsolicitacao',
        name: 'edicaoSolicitacaoRecargaCartao',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoRecargaCartaoView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro Solicitacao de Reembolso
    {
        path: '/projetos/:id/solicitacaoreembolso/',
        name: 'cadastroSolicitacaoReembolso',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoReembolsoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição Solicitacao de Reembolso
    {
        path: '/solicitacaoreembolso/:idsolicitacao',
        name: 'edicaoSolicitacaoReembolso',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoReembolsoView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Edição Solicitacao de Pagamento de Material de Consumo
    {
        path: '/solicitacaopagamentomaterial/:idsolicitacao',
        name: 'edicaoSolicitacaoPagamentoMaterial',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoMaterialView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro Solicitacao de Pagamento de Material de Consumo
    {
        path: '/projetos/:id/solicitacaopagamentomaterial/',
        name: 'cadastroSolicitacaoPagamentoMaterial',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoMaterialView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Cadastro de Solicitação de Pagamento de Premiação
    {
        path: '/projetos/:id/solicitacaopagamentopremiacao/',
        name: 'cadastroSolicitacaoPagamentoPremiacao',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoPremiacaoView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoPagamentoPremiacao ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição de Solicitação de Pagamento de Premiação
    {
        path: '/solicitacaopagamentopremiacao/:idsolicitacao',
        name: 'edicaoSolicitacaoPagamentoPremiacao',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoPremiacaoView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoPagamentoPremiacao ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro de Solicitação de PJ
    {
        path: '/projetos/:id/solicitacoescadastropessoajuridica/',
        name: 'cadastroSolicitacaoPessoaJuridica',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPessoaJuridicaView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoCadastroPessoaJuridica ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Cadastro de PJ
    {
        path: '/solicitacoescadastropessoajuridica/:idsolicitacao',
        name: 'edicaoSolicitacaoCadastroPessoaJuridica',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPessoaJuridicaView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoCadastroPessoaJuridica ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Solicitação de Cancelamento de Contrato
    {
        path: '/projetos/:id/solicitacoescancelamentodecontrato/',
        name: 'cadastroSolicitacaoCancelamentoContrato',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoCancelamentoContratoView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoCancelamentoContrato ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição Solicitacao de Cancelamento de Contrato
    {
        path: '/solicitacoescancelamentodecontrato/:idsolicitacao',
        name: 'edicaoSolicitacaoCancelamentoContrato',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoCancelamentoContratoView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoCancelamentoContrato ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro de Solicitação de Empréstimo
    {
        path: '/projetos/:id/solicitacaoemprestimo/',
        name: 'cadastroSolicitacaoEmprestimo',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoEmprestimoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição de Solicitação de Empréstimo
    {
        path: '/solicitacaoemprestimo/:idsolicitacao',
        name: 'edicaoSolicitacaoEmprestimo',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoEmprestimoView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro de Solicitação de Locação de Veículo
    {
        path: '/projetos/:id/solicitacaolocacao/',
        name: 'cadastroSolicitacaoLocacaoVeiculo',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoLocacaoVeiculoView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoLocacaoVeiculo ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição de Solicitação de Locação de Veículo
    {
        path: '/solicitacaolocacao/:idsolicitacao',
        name: 'edicaoSolicitacaoLocacaoVeiculo',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoLocacaoVeiculoView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoLocacaoVeiculo ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro de Solicitação de Pagamento de Empréstimo
    {
        path: '/projetos/:id/solicitacaopagamentoemprestimo/',
        name: 'cadastroSolicitacaoPagamentoEmprestimo',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoPagamentoEmprestimoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Cadastro de Solicitação de Auxílio Financeiro em Lote
    {
        path: '/projetos/:id/solicitacaoauxiliofinanceirolote/',
        name: 'cadastroSolicitacaoAuxilioFinanceiroLote',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoAuxilioFinanceiroLoteView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Cadastro de Solicitação de Retirada DOA
    {
        path: '/projetos/:id/solicitacaoretiradadoa/',
        name: 'cadastroSolicitacaoRetiradaDoa',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoRetiradaDoaView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Cadastro de Solicitação de Ressarcimento à Apoiada
    {
        path: '/projetos/:id/solicitacaoressarcimentoapoiada/',
        name: 'cadastroSolicitacaoRessarcimentoApoiada',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoRessarcimentoApoiadaView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição de Solicitação de Ressarcimento à Apoiada
    {
        path: '/solicitacaoressarcimentoapoiada/:idsolicitacao',
        name: 'edicaoSolicitacaoRessarcimentoApoiada',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoRessarcimentoApoiadaView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro de Solicitação de Cadastro de PF
    {
        path: '/projetos/:id/solicitacoescadastropessoafisica/',
        name: 'cadastroSolicitacaoCadastroPessoaFisica',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoCadastroPessoaFisicaView.vue'),
        meta: { requiresAuth: true, ...(exibirSolicitacaoCadastroPessoaFisica ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Edição de Solicitação de Cadastro de PF
    {
        path: '/solicitacoescadastropessoafisica/:idsolicitacao',
        name: 'edicaoSolicitacaoCadastroPessoaFisica',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoCadastroPessoaFisicaView.vue'),
        meta: { requiresAuth: true, isEdicao: true, ...(exibirSolicitacaoCadastroPessoaFisica ? {} : { allowedRoles: ['disabled'] }) },
        props: true
    },
    // Cadastro de Solicitação de Devolução ao Órgão Financiador
    {
        path: '/projetos/:id/solicitacaodevolucaoaoorgaofinanciador/',
        name: 'cadastroSolicitacaoDevolucaoAoOrgaoFinanciador',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoDevolucaoAoOrgaoFinanciadorView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição de Solicitação de Devolução ao Órgão Financiador
    {
        path: '/solicitacaodevolucaoaoorgaofinanciador/:idsolicitacao',
        name: 'edicaoSolicitacaoDevolucaoAoOrgaoFinanciador',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoDevolucaoAoOrgaoFinanciadorView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro de Solicitação de Retirada de Rendimentos
    {
        path: '/projetos/:id/solicitacaoretiradarendimentos/',
        name: 'cadastroSolicitacaoRetiradaRendimentos',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoRetiradaRendimentosView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição de Solicitação de Retirada de Rendimentos
    {
        path: '/solicitacaoretiradarendimentos/:idsolicitacao',
        name: 'edicaoSolicitacaoRetiradaRendimentos',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoRetiradaRendimentosView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro de Solicitação de Suprimento de Fundos
    {
        path: '/projetos/:id/solicitacaosuprimentofundos/',
        name: 'cadastroSolicitacaoSuprimentoFundos',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoSuprimentoFundosView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Edição de Solicitação de Suprimento de Fundos
    {
        path: '/solicitacaosuprimentofundos/:idsolicitacao',
        name: 'edicaoSolicitacaoSuprimentoFundos',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoSuprimentoFundosView.vue'),
        meta: { requiresAuth: true, isEdicao: true },
        props: true
    },
    // Cadastro de Solicitação de Transferência Bancária entre Contas
    {
        path: '/projetos/:id/solicitacaotransferenciabancariaentrecontas/',
        name: 'cadastroSolicitacaoTransferenciaBancariaEntreContas',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoTransferenciaBancariaEntreContasView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
    // Cadastro de Solicitação de Receita por Encerramento
    {
        path: '/projetos/:id/solicitacaoreceitaporencerramento/',
        name: 'cadastroSolicitacaoReceitaPorEncerramento',
        component: () => import('@/modules/projeto/views/solicitacoes/CadastroSolicitacaoReceitaPorEncerramentoView.vue'),
        meta: { requiresAuth: true },
        props: true
    },
]
